import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M27.719 12.969l-11 11-.719.688-.719-.688-11-11 1.438-1.438L16 21.812l10.281-10.281z" /></svg>);